// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 15px;
    box-sizing: border-box;
}

.notfound-wrapper {
    width: 100%;
    margin-top: 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.notfound-line-divider {
    width: 100%;
    border-bottom: 1px solid #ddd;
}

.notfound-text {
    font-family: "Rigidica Text Regular", sans-serif;
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.notfound-text h2 {
    font-family: "Rigidica Text Bold", sans-serif;
    font-size: 10rem;
    letter-spacing: 0.06em;
    white-space: nowrap;
    border: none;
    color: #333;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
    margin-bottom: 0;
    margin-top: 20px;
}

.notfound-text p {
    font-family: "Rigidica Text Regular", sans-serif;
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 30px;
    letter-spacing: 0.06em;
    color: #333;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
}

#notfound-additional-text {
    font-size: 0.875rem;
    margin-top: 30px;
    margin-bottom: 20px;
    color: #333;
    letter-spacing: 0.06em;
    -webkit-user-select: auto;
            user-select: auto;
    -webkit-user-drag: auto;
}

.notfound-return-home-button {
    width: 100%;
    padding: 10px;
    background-color: #333;
    margin-bottom: 10px;
    color: white;
    border: none;
    border-radius: 4px;
    font-family: "Rigidica Text Regular", sans-serif;
    text-align: center;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.3s ease;
}

.notfound-return-home-button:hover {
    background-color: #555;
}

/* Media Queries */

@media (max-width: 599px) {
    .notfound-text h2 {
        font-size: 6rem;
        margin-top: 10px;
    }

    .notfound-text p {
        font-size: 1.2rem;
        margin-bottom: 20px;
    }

    #notfound-additional-text {
        font-size: 0.75rem;
        margin-top: 20px;
        margin-bottom: 15px;
    }

    .notfound-container {
        margin-top: 5px;
        padding-bottom: 10px;
    }

    .notfound-wrapper {
        padding: 0.5rem;
    }
}

@media (min-width: 600px) and (max-width: 767px) {
    .notfound-text h2 {
        font-size: 7rem;
        margin-top: 15px;
    }

    .notfound-text p {
        font-size: 1.3rem;
        margin-bottom: 25px;
    }

    #notfound-additional-text {
        font-size: 0.8rem;
        margin-top: 25px;
        margin-bottom: 15px;
    }

    .notfound-container {
        padding-bottom: 15px;
    }

    .notfound-wrapper {
        padding: 0.75rem;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .notfound-text h2 {
        font-size: 8rem;
        margin-top: 18px;
    }

    .notfound-text p {
        font-size: 1.4rem;
        margin-bottom: 28px;
    }

    #notfound-additional-text {
        font-size: 0.85rem;
        margin-top: 28px;
        margin-bottom: 18px;
    }

    .notfound-container {
        padding-bottom: 20px;
    }

    .notfound-wrapper {
        padding: 1rem;
    }
}

@media (min-width: 1024px) and (max-width: 1279px) {
    .notfound-text h2 {
        font-size: 9rem;
        margin-top: 20px;
    }

    .notfound-text p {
        font-size: 1.45rem;
        margin-bottom: 30px;
    }

    #notfound-additional-text {
        font-size: 0.875rem;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .notfound-container {
        padding-bottom: 22px;
    }

    .notfound-wrapper {
        padding: 1.25rem;
    }
}

@media (min-width: 1280px) and (max-width: 1439px) {
    .notfound-text h2 {
        font-size: 10rem;
        margin-top: 22px;
    }

    .notfound-text p {
        font-size: 1.5rem;
        margin-bottom: 32px;
    }

    #notfound-additional-text {
        font-size: 0.875rem;
        margin-top: 32px;
        margin-bottom: 22px;
    }

    .notfound-container {
        padding-bottom: 25px;
    }

    .notfound-wrapper {
        padding: 1.5rem;
    }
}

@media (min-width: 1440px) and (max-width: 1535px) {
    .notfound-text h2 {
        font-size: 10.5rem;
        margin-top: 25px;
    }

    .notfound-text p {
        font-size: 1.55rem;
        margin-bottom: 34px;
    }

    #notfound-additional-text {
        font-size: 0.9rem;
        margin-top: 34px;
        margin-bottom: 24px;
    }

    .notfound-container {
        padding-bottom: 28px;
    }

    .notfound-wrapper {
        padding: 1.75rem;
    }
}

@media (min-width: 1536px) and (max-width: 1919px) {
    .notfound-text h2 {
        font-size: 11rem;
        margin-top: 28px;
    }

    .notfound-text p {
        font-size: 1.6rem;
        margin-bottom: 36px;
    }

    #notfound-additional-text {
        font-size: 0.925rem;
        margin-top: 36px;
        margin-bottom: 26px;
    }

    .notfound-container {
        padding-bottom: 30px;
    }

    .notfound-wrapper {
        padding: 2rem;
    }

    .notfound-return-home-button {
        margin-bottom: 35px;
    }
}

@media (min-width: 1920px) and (max-width: 2559px) {
    .notfound-text h2 {
        font-size: 12rem;
        margin-top: 32px;
    }

    .notfound-text p {
        font-size: 1.7rem;
        margin-bottom: 38px;
    }

    #notfound-additional-text {
        font-size: 0.95rem;
        margin-top: 38px;
        margin-bottom: 28px;
    }

    .notfound-container {
        padding-bottom: 32px;
    }

    .notfound-wrapper {
        padding: 2.25rem;
    }

    .notfound-return-home-button {
        padding: 12px;
        margin-bottom: 40px;
    }
}

@media (min-width: 2560px) {
    .notfound-text h2 {
        font-size: 13rem;
        margin-top: 36px;
    }

    .notfound-text p {
        font-size: 1.8rem;
        margin-bottom: 40px;
    }

    #notfound-additional-text {
        font-size: 1rem;
        margin-top: 40px;
        margin-bottom: 30px;
    }

    .notfound-container {
        padding-bottom: 35px;
    }

    .notfound-wrapper {
        padding: 2.5rem;
    }

    .notfound-return-home-button {
        padding: 15px;
        margin-bottom: 45px;
        font-size: 1.1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/NotFoundPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,gDAAgD;IAChD,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,kBAAkB;;AAElB;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;AACJ","sourcesContent":[".notfound-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding-top: 15px;\n    box-sizing: border-box;\n}\n\n.notfound-wrapper {\n    width: 100%;\n    margin-top: 0;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n}\n\n.notfound-line-divider {\n    width: 100%;\n    border-bottom: 1px solid #ddd;\n}\n\n.notfound-text {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    box-sizing: border-box;\n    padding: 0 8px;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.notfound-text h2 {\n    font-family: \"Rigidica Text Bold\", sans-serif;\n    font-size: 10rem;\n    letter-spacing: 0.06em;\n    white-space: nowrap;\n    border: none;\n    color: #333;\n    user-select: none;\n    -webkit-user-drag: none;\n    margin-bottom: 0;\n    margin-top: 20px;\n}\n\n.notfound-text p {\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    text-align: center;\n    font-size: 1.5rem;\n    margin-bottom: 30px;\n    letter-spacing: 0.06em;\n    color: #333;\n    user-select: none;\n    -webkit-user-drag: none;\n}\n\n#notfound-additional-text {\n    font-size: 0.875rem;\n    margin-top: 30px;\n    margin-bottom: 20px;\n    color: #333;\n    letter-spacing: 0.06em;\n    user-select: auto;\n    -webkit-user-drag: auto;\n}\n\n.notfound-return-home-button {\n    width: 100%;\n    padding: 10px;\n    background-color: #333;\n    margin-bottom: 10px;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n    text-align: center;\n    cursor: pointer;\n    text-decoration: none;\n    transition: background-color 0.3s ease;\n}\n\n.notfound-return-home-button:hover {\n    background-color: #555;\n}\n\n/* Media Queries */\n\n@media (max-width: 599px) {\n    .notfound-text h2 {\n        font-size: 6rem;\n        margin-top: 10px;\n    }\n\n    .notfound-text p {\n        font-size: 1.2rem;\n        margin-bottom: 20px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.75rem;\n        margin-top: 20px;\n        margin-bottom: 15px;\n    }\n\n    .notfound-container {\n        margin-top: 5px;\n        padding-bottom: 10px;\n    }\n\n    .notfound-wrapper {\n        padding: 0.5rem;\n    }\n}\n\n@media (min-width: 600px) and (max-width: 767px) {\n    .notfound-text h2 {\n        font-size: 7rem;\n        margin-top: 15px;\n    }\n\n    .notfound-text p {\n        font-size: 1.3rem;\n        margin-bottom: 25px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.8rem;\n        margin-top: 25px;\n        margin-bottom: 15px;\n    }\n\n    .notfound-container {\n        padding-bottom: 15px;\n    }\n\n    .notfound-wrapper {\n        padding: 0.75rem;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .notfound-text h2 {\n        font-size: 8rem;\n        margin-top: 18px;\n    }\n\n    .notfound-text p {\n        font-size: 1.4rem;\n        margin-bottom: 28px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.85rem;\n        margin-top: 28px;\n        margin-bottom: 18px;\n    }\n\n    .notfound-container {\n        padding-bottom: 20px;\n    }\n\n    .notfound-wrapper {\n        padding: 1rem;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1279px) {\n    .notfound-text h2 {\n        font-size: 9rem;\n        margin-top: 20px;\n    }\n\n    .notfound-text p {\n        font-size: 1.45rem;\n        margin-bottom: 30px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.875rem;\n        margin-top: 30px;\n        margin-bottom: 20px;\n    }\n\n    .notfound-container {\n        padding-bottom: 22px;\n    }\n\n    .notfound-wrapper {\n        padding: 1.25rem;\n    }\n}\n\n@media (min-width: 1280px) and (max-width: 1439px) {\n    .notfound-text h2 {\n        font-size: 10rem;\n        margin-top: 22px;\n    }\n\n    .notfound-text p {\n        font-size: 1.5rem;\n        margin-bottom: 32px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.875rem;\n        margin-top: 32px;\n        margin-bottom: 22px;\n    }\n\n    .notfound-container {\n        padding-bottom: 25px;\n    }\n\n    .notfound-wrapper {\n        padding: 1.5rem;\n    }\n}\n\n@media (min-width: 1440px) and (max-width: 1535px) {\n    .notfound-text h2 {\n        font-size: 10.5rem;\n        margin-top: 25px;\n    }\n\n    .notfound-text p {\n        font-size: 1.55rem;\n        margin-bottom: 34px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.9rem;\n        margin-top: 34px;\n        margin-bottom: 24px;\n    }\n\n    .notfound-container {\n        padding-bottom: 28px;\n    }\n\n    .notfound-wrapper {\n        padding: 1.75rem;\n    }\n}\n\n@media (min-width: 1536px) and (max-width: 1919px) {\n    .notfound-text h2 {\n        font-size: 11rem;\n        margin-top: 28px;\n    }\n\n    .notfound-text p {\n        font-size: 1.6rem;\n        margin-bottom: 36px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.925rem;\n        margin-top: 36px;\n        margin-bottom: 26px;\n    }\n\n    .notfound-container {\n        padding-bottom: 30px;\n    }\n\n    .notfound-wrapper {\n        padding: 2rem;\n    }\n\n    .notfound-return-home-button {\n        margin-bottom: 35px;\n    }\n}\n\n@media (min-width: 1920px) and (max-width: 2559px) {\n    .notfound-text h2 {\n        font-size: 12rem;\n        margin-top: 32px;\n    }\n\n    .notfound-text p {\n        font-size: 1.7rem;\n        margin-bottom: 38px;\n    }\n\n    #notfound-additional-text {\n        font-size: 0.95rem;\n        margin-top: 38px;\n        margin-bottom: 28px;\n    }\n\n    .notfound-container {\n        padding-bottom: 32px;\n    }\n\n    .notfound-wrapper {\n        padding: 2.25rem;\n    }\n\n    .notfound-return-home-button {\n        padding: 12px;\n        margin-bottom: 40px;\n    }\n}\n\n@media (min-width: 2560px) {\n    .notfound-text h2 {\n        font-size: 13rem;\n        margin-top: 36px;\n    }\n\n    .notfound-text p {\n        font-size: 1.8rem;\n        margin-bottom: 40px;\n    }\n\n    #notfound-additional-text {\n        font-size: 1rem;\n        margin-top: 40px;\n        margin-bottom: 30px;\n    }\n\n    .notfound-container {\n        padding-bottom: 35px;\n    }\n\n    .notfound-wrapper {\n        padding: 2.5rem;\n    }\n\n    .notfound-return-home-button {\n        padding: 15px;\n        margin-bottom: 45px;\n        font-size: 1.1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
